var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.396 8.488a.687.687 0 00-.772.209 5.49 5.49 0 01-4.26 2.017 5.512 5.512 0 01-5.506-5.506c0-1.528.617-2.95 1.736-4.004A.687.687 0 008.056.018 8.89 8.89 0 000 8.902c0 4.923 4.005 8.928 8.928 8.928a8.877 8.877 0 008.916-8.677.69.69 0 00-.448-.665zm-8.468 7.965c-4.165 0-7.552-3.387-7.552-7.551a7.519 7.519 0 015.018-7.119 6.806 6.806 0 00-.912 3.426 6.89 6.89 0 006.883 6.882 6.855 6.855 0 003.837-1.168 7.5 7.5 0 01-7.274 5.53z",
    fill: "#647A97",
    fillRule: "nonzero"
  })));
}
export default SvgHalfMoon;